import React from 'react'
import { observer } from 'mobx-react'
import { Tooltip, OverlayTrigger, Button, DropdownButton, MenuItem } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'

const LanguagesTabsEdit = ({ disabled, store, gotoRefs, assetRefs }) => {
  const TYPE_ATTR = 'attributes'
  const TYPE_ENUMS = 'enums'
  const TYPE_PERSONS = 'persons'
  const TYPE_UPLOADS = 'uploads'
  const MESSAGE_COPY = store.__('Copy EN text into all other missing languages')
  const MESSAGE_EDIT = store.__('Edit original text or add new value if missing')
  const langs = store.activeLanguages
  const typeIsMissing = {
    [TYPE_ATTR]: [],
    [TYPE_ENUMS]: [],
    [TYPE_PERSONS]: [],
    [TYPE_UPLOADS]: []
  }

  const isEntityChanged = store.cv.isEntityChanged &&
    <div className='alert alert-dismissible alert-warning'>
      <strong>{store.__('Warning:').concat(' ')}</strong>
      {store.__('Please save this "film" first so that you can view all the language data.')}
    </div>

  const addToLangTAB = (lng, params) => {
  // add to language tab table
    const tempAttr = store.cv.attributes.find(j =>
      j.metadata_type === params.metadata_type &&
      j.language === lng &&
      j.attribute_id === params.attribute_id &&
      j.attribute_name_internal === params.attribute_name_internal)

    if (!tempAttr) {
      store.cv.attributes.push(Object.assign({}, params, { language: lng }))
    } else if (!tempAttr.attribute_value) {
      tempAttr.attribute_value = params.attribute_value
    }
  }

  const openSaveAction = (params, newLang, addLangs = false) => {
    const avalue = params.attribute_value
    const alang = newLang || params.language
    const copied = []
    let openOrSave = null
    let tempItem = null

    switch (params.metadata_type) {
    case TYPE_ATTR:
      openOrSave = () => {
        if (addLangs) {
          copied.length = 0
          langs.map(lng => {
            tempItem = store.cv.record.get('attrs')
              .find(j => j.lang === lng && j.name === params.attribute_name_internal)
            if (!tempItem || !tempItem.value) {
              copied.push(lng.toUpperCase())
              store.cv.record.get('attrs').push(
                { platform: 'common', name: params.attribute_name_internal, lang: lng, value: avalue }
              )
              store.cv.record.set('updated', new Date())
              addToLangTAB(lng, params)
            }
          })
          copied && copied.length > 0
            ? store.addMessage('copied to ' + copied.join(', '), 'info')
            : store.addMessage('there is nothing to copy', 'warning')
        } else {
          newLang && store.cv.record.get('attrs').push(
            { platform: 'common', name: params.attribute_name_internal, lang: alang, value: '' }
          )
          store.setActiveLanguage(alang)
          store.assetTabEvent('basic', 1)
          store.assetTabEvent('common', 1)
          gotoRefs('common-lang', params.attribute_name_internal + '-' + alang)
        }
      }
      break

    case TYPE_ENUMS:
      openOrSave = () => {
        if (addLangs && params.attribute_id) {
          const [parent, child] = params.attribute_id.split('|')
          const url = `/enums/${encodeURIComponent(child)}/${encodeURIComponent(parent)}`

          parent && child && store.requester.call(url)
            .then(result => {
              const copied = []
              const data = result.data

              langs.map(lng => {
                tempItem = data.find(j => j.lang === lng)
                if (!tempItem) {
                  data.push({ lang: lng, text: avalue, parent: parent, value: child })
                  copied.push(lng.toUpperCase())
                } else if (!tempItem.text) {
                  tempItem.text = avalue
                  copied.push(lng.toUpperCase())
                }
                addToLangTAB(lng, params)
              })

              return [copied, data]
            })
            .then(([copied, result]) => {
              store.requester.call(url, 'put', result)
                .then(_ => {
                  copied && copied.length > 0
                    ? store.addMessage('copied and saved to ' + copied.join(', '), 'success')
                    : store.addMessage('there is nothing to copy', 'warning')
                })
                .catch(store.onRequesterError)
            })
            .catch(store.onRequesterError)
        } else {
          const entityParams = {
            entityname: linkConst.LINK_ENUMS,
            id: params.attribute_id,
            langtab: alang,
            params: params
          }
          store.modalEntityControl(entityParams)
        }
      }
      break

    case TYPE_PERSONS:
      openOrSave = () => {
        if (addLangs && params.attribute_id) {
          const url = `/persons/${params.attribute_id}`
          store.requester.call(url)
            .then(result => {
              const copied = []
              const data = result.data

              langs.map(lng => {
                tempItem = data.name.find(j => j.lang === lng)
                if (!tempItem) {
                  data.name.push({ lang: lng, value: avalue })
                  copied.push(lng.toUpperCase())
                } else if (!tempItem.value) {
                  tempItem.value = avalue
                  copied.push(lng.toUpperCase())
                }
                addToLangTAB(lng, params)
              })

              return [copied, data]
            })
            .then(([copied, result]) => {
              store.requester.call(url, 'put', result)
                .then(r => {
                  copied && copied.length > 0
                    ? store.addMessage('copied and saved to ' + copied.join(', '), 'success')
                    : store.addMessage('there is nothing to copy', 'warning')
                })
                .catch(store.onRequesterError)
            })
            .catch(store.onRequesterError)
        } else {
          const entityParams = {
            entityname: linkConst.LINK_PERSONS,
            id: params.attribute_id,
            type: 'entity',
            langtab: alang,
            params: params
          }
          store.modalEntityControl(entityParams)
        }
      }
      break

    case TYPE_UPLOADS:
      openOrSave = () => {
        store.assetTabEvent('basic', 2)
        store.assetTabEvent('flyprivate',
          params.attribute_name_internal.indexOf('subtitle') >= 0 ? 2 : 1)
        window.scrollTo(0, 0)
      }
      break
    }
    const icon = addLangs ? 'glyphicon glyphicon-duplicate' : 'glyphicon glyphicon-edit'
    const title = addLangs ? MESSAGE_COPY : alang.toUpperCase().concat(' - ') + MESSAGE_EDIT
    return <OverlayTrigger overlay={<Tooltip>{title}</Tooltip>} placement='top'>
      <a href='javascript:void(0);'
        onClick={openOrSave}
        className='lang-edit'>
        <i className={icon} />
      </a>
    </OverlayTrigger>
  }

  const listOfLanguages = store.options.has('FilmCargoLanguages') && store.options.get('FilmCargoLanguages')
  const AddLanguageDropDown = observer(({ store }) => {
    const title = (<span>
      <i className='glyphicon glyphicon-plus-sign' />&nbsp;
      {store.activeLanguages.length <= 6 ? store.__('Add language') : store.__('Add')}
    </span>)
    const confirmRemove = store.__('Really remove this language?')

    return !disabled && listOfLanguages && listOfLanguages.length > 0 &&
      <div className='languages-dropdown' style={{ float: 'left' }}>
        <DropdownButton bsStyle='primary' bsSize='small' title={title}>
          {listOfLanguages.map(i => {
            const lang = i.value
            const isEN = lang === defaultConst.DEFAULT_LANG
            const isActive = store.activeLanguages.includes(lang) || isEN

            return (
              <MenuItem key={lang} eventKey={lang} tabClassName={isActive && 'text-info'} disabled={isEN}
                onClick={isEN
                  ? undefined
                  : () => isActive
                    ? confirm(confirmRemove) && store.updateAttrsLanguage(store, lang, true)
                    : store.updateAttrsLanguage(store, lang)
                }>
                {isEN
                  ? <span><span className='glyphicon glyphicon-ban-circle' /></span>
                  : (isActive
                    ? <span className='text-danger'><span className='glyphicon glyphicon-remove' /></span>
                    : <span className='text-success'><span className='glyphicon glyphicon-plus-sign' /></span>)
                } &nbsp;
                {i.text}
                {isEN && <em>&nbsp;({store.__('default')})</em>}
              </MenuItem>
            )
          })
          }
        </DropdownButton>
      </div>
  })

  const copyTitleAndSynopsis = () => {
    const copied = []
    store.cv.attributes
      .filter(i => i.metadata_type === TYPE_ATTR && i.language === defaultConst.DEFAULT_LANG)
      .map(params => {
        langs.map(lng => {
          const tempItem = store.cv.record.get('attrs').find(j => j.lang === lng && j.name === params.attribute_name_internal)
          if (!tempItem || !tempItem.value) {
            copied.push(lng.toUpperCase())
            store.cv.record.get('attrs').push(
              { platform: 'common', name: params.attribute_name_internal, lang: lng, value: params.attribute_value }
            )
            store.cv.record.set('updated', new Date())
            addToLangTAB(lng, params)
          }
        })
      })
    copied && copied.length > 0
      ? store.addMessage('EN text copied to ' + [...new Set(copied)].join(', '), 'info')
      : store.addMessage('there is nothing to copy', 'warning')
  }

  const copyCastAndCrew = () => {
    if (!typeIsMissing[TYPE_PERSONS] || typeIsMissing[TYPE_PERSONS].length <= 0) {
      store.addMessage('there is nothing to copy', 'warning')
      return true
    }
    store.cv.attributes
      .filter(i => i.metadata_type === TYPE_PERSONS && i.language === defaultConst.DEFAULT_LANG)
      .map(params => {
        const url = `/persons/${params.attribute_id}`
        store.requester.call(url)
          .then(result => {
            const copied = []
            const data = result.data

            langs.map(lng => {
              const tempItem = data.name.find(j => j.lang === lng)
              if (!tempItem) {
                data.name.push({ lang: lng, value: params.attribute_value })
                copied.push(lng.toUpperCase())
              } else if (!tempItem.value) {
                tempItem.value = params.attribute_value
                copied.push(lng.toUpperCase())
              }
              addToLangTAB(lng, params)
            })

            return [copied, data]
          })
          .then(([copied, result]) => {
            return (!copied || copied.length <= 0)
              ? true
              : store.requester.call(url, 'put', result)
                .then(_ => {
                  store.addMessage(params.attribute_value + ' copied and saved to ' + [...new Set(copied)].join(', '), 'success')
                  return true
                })
                .catch(store.onRequesterError)
          })
          .catch(store.onRequesterError)
      })
  }

  const addButtons = <div>
    <AddLanguageDropDown store={store} />
    <OverlayTrigger overlay={<Tooltip>{MESSAGE_COPY}</Tooltip>} placement='top'>
      <Button bsStyle='info' bsSize='small' style={{ marginLeft: '1em' }} onClick={() => copyTitleAndSynopsis()}>
        <i className='glyphicon glyphicon-duplicate' />&nbsp; {store.__('Copy title and synopsis')}
      </Button>
    </OverlayTrigger>
    <OverlayTrigger overlay={<Tooltip>{MESSAGE_COPY}</Tooltip>} placement='top'>
      <Button bsStyle='info' bsSize='small' style={{ marginLeft: '1em' }} onClick={() => copyCastAndCrew()}>
        <i className='glyphicon glyphicon-duplicate' />&nbsp; {store.__('Copy cast and crew names')}
      </Button>
    </OverlayTrigger>
  </div>

  const renderAttributes = (attrs) => {
    const langs = store.activeLanguages
    const tbody = []
    const thead = <tr>
      <th colSpan={2}>&nbsp;</th>
      {langs && langs.map((v, k) =>
        <th className='lang-separator' colSpan={2} key={k}>
          <strong className='lang-title'>{v && v.toUpperCase()}</strong>
        </th>)}
    </tr>
    const missing = <span className='label label-danger'>{store.__('missing')}</span>
    const missingLangs = []
    let attrLatest = ''
    let nameLatest = ''
    let c = 1

    attrs.map(i => {
      if (nameLatest !== i.attribute_id) {
        nameLatest = i.attribute_id
        c = 1
      } else if (i.metadata_type === TYPE_UPLOADS) {
        i.attribute_id = i.attribute_id + (c++)
      }

      const enMissing = !attrs.find(j => j.language === defaultConst.DEFAULT_LANG && j.attribute_id === nameLatest)
      if (i.language !== defaultConst.DEFAULT_LANG && enMissing && langs.includes(i.language)) {
        missingLangs.push(Object.assign({}, i))
        i.language = defaultConst.DEFAULT_LANG
        i.attribute_value = ''
      }
      return i
    }).filter(i => i.language === defaultConst.DEFAULT_LANG).map(def => {
      let attrName = def.attribute_name_flyprivate.replaceAll('-', ' ').replaceAll('_', ' ')

      const row = langs.map(lang => {
        const item = attrs.concat(missingLangs).find(i => {
          return i.language === lang &&
            i.attribute_id === def.attribute_id &&
            i.attribute_name_flyprivate === def.attribute_name_flyprivate
        })
        if (!item) {
          typeIsMissing[def.metadata_type].push(lang)
        }

        return item && String(item.attribute_value) !== ''
          ? [openSaveAction(item), <p key={item.attribute_id}>{item.attribute_value}</p>]
          : (def.metadata_type === TYPE_UPLOADS
            ? ['', '']
            : [openSaveAction(def, lang), missing])
      })
      if (attrName !== attrLatest) {
        attrLatest = attrName
      } else {
        attrName = ''
      }

      tbody.push(<tr>
        <td><strong className='first-to-uppercase'>{attrName}</strong></td>
        {[TYPE_ATTR, TYPE_PERSONS, TYPE_ENUMS].indexOf(def.metadata_type) >= 0 && String(def.attribute_value) !== ''
          ? <td>{openSaveAction(def, def.language, true)}</td>
          : <td></td>
        }
        {row.map((v, k) =>
          <React.Fragment key={k}>
            <td className='lang-separator'>{v[0]}</td>
            <td>{v[1]}</td>
          </React.Fragment>)}
      </tr>)
    })

    return <table className='table table-striped asset-langs'>
      <thead>{thead}</thead>
      <tbody>{tbody}</tbody>
      <tfoot>{thead}</tfoot>
    </table>
  }

  return (
    <div className='card'>
      {store.cv.attrsState === 'loading'
        ? <div><br /><span className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />&nbsp; {store.__('Loading...')}</div>
        : (store.cv.items && store.cv.attributes.length > 0
          ? [isEntityChanged, addButtons, renderAttributes(store.cv.attributes)]
          : <div><br />- {store.__('NO DATA or UNSAVED record')} -</div>
        )
      }
      <br />
      {store.cv.items && store.cv.attributes.length > 0 &&
      <div className='alert alert-dismissible alert-info'>
        <p>&nbsp;
          <strong>{store.__('Info:')}</strong> &nbsp;&nbsp;&nbsp;
          <i className='glyphicon glyphicon-duplicate' />&nbsp;&nbsp;{MESSAGE_COPY}
            &nbsp; | &nbsp;
          <i className='glyphicon glyphicon-edit' />&nbsp;&nbsp;{MESSAGE_EDIT}
        </p>
      </div>}
    </div>
  )
}

export default observer(LanguagesTabsEdit)
